export default {
  邮件号: '邮件号',
  通讯录云数据库: '通讯录云数据库',
  云展访问人数: '云展访问人数',
  云展访问量: '云展访问量',
  邮件阅读量: '邮件阅读量',
  访问量: '访问量',
  数据持续收集中: '数据持续收集中',
  邮件ID: '邮件ID',
  发送类型: '发送类型',
  邀约信息: '邀约信息',
  邀约详情: '邀约详情',
  新建: '新建',
  请上传附件: '请上传附件',
  预计费用: '预计费用',
  分条: '分条',
  内容: '内容',
  国际区号: '国际区号',
  链接材料文件大小限制提示: '文件/图片大小不可以超过 10MB!',
  最多可上传3个文件: '最多可上传3个文件',
  链接描述最多输入120个字符: '链接描述最多输入120个字符',
  链接描述不能为空: '链接描述不能为空',
  链接最多输入500个字符: '链接最多输入500个字符',
  链接不能为空: '链接不能为空',
  链接名称最多输入10个字符: '链接名称最多输入10个字符',
  链接名称不能为空: '链接名称不能为空',
  链接提示5: '最多可上传3个文件,支持图片、文档,不超过10M',
  链接提示4: '若链接需要用在多媒体邀约,则需要提供该链接的ICP备案证书（工业和信息化部政务平台-ICP备案查询）',
  链接提示3: '请如实详细描述该链接,以便于运营商进行审核',
  链接提示2: '请复制完整的链接域名,黏贴到下方输入框',
  链接提示1: '主要用于链接的标识管理',
  创建链接: '创建链接',
  邀约必须为22: '邀约必须为2-8个字符!',
  邀约不能为空: '邀约不能为空!',
  下载: '下载',
  资质证明材料: '资质证明材料',
  创建多媒体邀约签名: '创建多媒体邀约签名',
  创建普通邀约: '创建普通邀约',
  最少输入10000点提示1: '最少输入10000点,最大可输入100万点！',
  请输入需要充值的点数: '请输入需要充值的点数',
  输入值不可包含小数点: '输入值不可包含小数点',
  自定义点数: '自定义点数',
  点数: '点数',
  确认充值: '确认充值',
  平均: '平均',
  邀约购买: '邀约购买',
  立即发送: '立即发送',
  点: '点',
  邀约首页: '邀约首页',
  链接管理: '链接管理',
  邀约首页提示语1:
    '1、普通邀约（纯文本）,70个字(含标点符号)以内（包含邀约）按1条短信计算,超过70个字符时,每增加67个字符,则多增加一条短信；每个标点、数字、字母、中文等均按照一个字符进行计算。',
  邀约首页提示语2:
    '2、多媒体邀约,邀约模板不能超过1.9M大小,视频上传文件不能超过50M（系统会自动压缩）,且建议播放时长不超过33秒,横屏视频建议1920*1080px,竖屏视频建议1080*1920px,图片大小建议50kb-1.8M范围,横屏图片建议1920*1080px,竖屏图片建议962*1300px;',
  邀约首页提示语3:
    '3、普通邀约费用1点/条,多媒体邀约费用4点/条,发送短信时,系统会根据发送的短信任务预冻结对应的短信点数,短信任务发送完成后,根据发送成功数进行抵扣,失败则退回对应的点数；',
  邀约首页提示语4:
    '4、发送短信、富信暂时仅支持国内+86（不包括中国香港、中国台湾、中国澳门）手机号的发送,国外的手机号暂不支持；',
  邀约首页提示语5: '5、邀约一旦审核通过不可再修改,请谨慎提交！',
  冻结中: '冻结中',
  短信余量: '点数',
  审核中: '审核中',
  审核拒绝: '审核拒绝',
  普通邀约签名: '普通邀约',
  多媒体邀约签名: '多媒体邀约签名',
  创建签名: '创建签名',
  // 立即充值即表示同意: '立即充值即表示同意',
  // 云展动力精准邀约服务使用协议: '云展动力精准邀约服务使用协议',
  什么叫普通邀约: '什么是普通邀约？什么是多媒体短信？',
  什么叫普通邀约提示: '普通邀约：只支持文本内容。多媒体邀约：支持文本,图片,视频内容。',
  发普通邀约: '发普通邀约',
  // 发多媒体邀约: '发多媒体邀约',

  // 创建签名
  创建普通邀约提示语1:
    '必须为本企业具有知识产权的品牌商标名称或企业简称,2-8个字符,不能含有特殊字符,如【】[],每个字母、汉字、数字均按照1个字符计算；',
  创建普通邀约提示语2: '2、申请签名提交后不可撤销,且审核通过后不可再修改！',
  资质证明提示语1: '1、请下载范本,按照要求填写完整,再点击上传,仅支持doc/docx文档格式；',
  资质证明提示语2:
    '2、需要上传签名授权书、企业营业执照扫描件（盖公章）,如签名与盖章企业不一致时,还需提供证明（证明包含商标授权书、官网产品介绍截图等文件）',
  // 预览短信: '预览短信',
  短信正文内容: '短信正文内容 回复T退订',

  // 发送平台短信
  发送平台短信: '发送平台短信',
  发送短信提示语1: '1、普通邀约费用1点/条,多媒体邀约费用4点/条；',
  发送短信提示语2:
    '2、发送短信、富信暂时仅支持国内（不包括中国香港、中国台湾、中国澳门）手机号的发送,国外的手机号暂不支持；',
  发送短信提示语3:
    '3、使用【大数据客户库】需要额外支付：普通邀约2点/手机号,多媒体邀约3点/手机号,举例：若发送40个字符的普通邀约模板,使用【大数据客户库】的手机号10个,则 总共费用：10*1点/条普通邀约+10*2点/手机号=30点',
  数据库标签: '数据库标签',

  请输入11位国内有效手机号: '请输入11位国内有效手机号,回车键确定',
  发送普通邀约注意信息: '注意：每次发送最多10万个号码,超过部分手机号不能发送',
  发送多媒体邀约注意信息: '注意：每次发送最多5万个号码,超过部分手机号不能发送',
  普通标签说明: '1、普通,指的是自己导入手机号码进行发送；',
  云数据标签说明普通: '2、云数据,指的是平台根据大数据分析,提供潜在的客户手机号码,每个手机号另外付费2个点',
  云数据标签说明富信: '2、云数据,指的是平台根据大数据分析,提供潜在的客户手机号码,每个手机号另外付费3个点',

  云数据: '云数据',
  '云数据&其他': '云数据&其他',
  发送主题提示语: '1、仅作发送短信的标记,不作为短信内容发送',
  发送手机提示语: '1、请输入11位有效手机号,仅支持国内（+86）手机号,输入时,不需要+86,直接输入11位手机号即可,回车键确定',
  选择短信模板提示语: '1、发送短信之前,请先创建好发送的邀约模板（普通模板与多媒体模板）,且必须通过平台审核才可以使用',
  确定发送: '确定发送',
  // 选择发送手机号
  选择发送手机号: '选择发送手机号',
  客户姓名: '客户姓名',
  发送的行业分类: '发送的行业分类',
  添加客户库: '添加客户库',
  // 选择模板
  选择普通邀约模板: '选择普通邀约模板',
  选择多媒体邀约模板: '选择多媒体邀约模板',
  点击预览: '点击预览',
  清空: '清空',
  确定是否清空: '确定要清空吗?',
  批量导入号码: '批量导入发送号码',
  批量导入提示语1: '1、仅支持xls、xlsx文件导入；',
  批量导入提示语2: '2、1行只能1个手机号码,仅支持国内11位有效手机号码(请严格按照样本示例导入,否则将导入失败!)；',
  通讯录导入手机号: '从我的通讯录导入手机号',
  通讯录导入群组: '从我的通讯录导入群组',

  请选择数据库标签: '请选择数据库标签!',
  请输入主题内容: '请输入主题内容!',
  最多填写10个字符: '最多填写10个字符',
  发送手机至少输入1个手机号: '发送手机至少输入1个手机号!',
  请选择发送的模板: '请选择发送的模板',

  // 链接管理
  链接管理提示语1:
    '1、发送短信时,若需要使用链接,必须先报备所要使用的链接,审核通过后,再生成短链接插入所报备的邀约模板；',
  链接管理提示语2: '2、未经过报备的任何链接,创建邀约模板时,均会被驳回；',
  链接管理提示语3:
    '3、严禁报备任何涉嫌暴力、反动、恐怖、赌博、涉黄、毒品等违法链接,一经发现,立即封禁账号,并同时将违法行为移交公安机关严肃处理！',
  链接管理提示语4: '4、若链接需要用在多媒体邀约,则需要提供该链接的ICP备案证书（工业和信息化部政务平台-ICP备案查询）',

  链接: '链接',
  发布记录: '发布记录',
  历史链接: '历史链接',
  效果: '效果',

  链接ID: '链接ID',
  链接描述: '链接描述',
  剩余有效天数: '剩余有效天数',
  编辑ID: '编辑ID',
  编辑类型: '编辑类型',

  链接名称: '链接名称',

  累计访问量: '累计访问量（人次）',
  累计访问人数: '累计访问人数（人）',
  访问明细列表: '访问明细列表',
  访问IP: '访问IP',
  最新访问时间: '最新访问时间',
  访问人次数: '访问人次数',
  独立访问人数: '独立访问人数',

  审核拒绝的原因: '审核拒绝的原因',
  链接相关证明材料附件: '链接相关证明材料附件',
  链接描述提示语: '1、请如实详细描述该链接,以便于运营商进行审核',
  链接提示语: '1、请复制完整的链接域名,黏贴到下方输入框',
  链接名称提示语: '1、主要用于链接的标识管理',
  链接附件提示语1: '1、若链接需要用在多媒体邀约,则需要提供该链接的ICP备案证书（工业和信息化部政务平台-ICP备案查询）',
  链接附件提示语2: '2、最多可上传3个文件,支持图片、文档,不超过10M',

  // 邀约记录
  普通邀约记录: '普通邀约记录',
  多媒体邀约记录: '多媒体邀约记录',
  发送明细: '发送明细',
  发送中短信提示语: '短信正在发送中,暂时不能查看发送明细,等状态变成已发送,则可以查看相关发送结果数据,最迟72个小时！',

  记录ID: '记录ID',
  任务批次: '任务批次',
  发送成功: '发送成功',
  发送失败: '发送失败',
  已发送: '已发送',
  待发送: '待发送',
  付费手机号: '付费手机号',
  任务状态: '任务状态',

  // 发送明细
  发送明细提示语: '注意：1、因系统数据比较庞大,发送之后分条数会动态分批更新！',
  发送分条数: '发送分条数',
  发送成功分条数: '发送成功分条数',
  发送失败分条数: '发送失败分条数',

  发送成功手机号: '发送成功手机号',
  发送对象: '发送对象',
  提交信息: '提交信息',

  邮件模板id: '邮件模板id',
  邮件发送主题: '邮件发送主题',
  发送数: '发送数',

  // 短信模板
  普通模板: '普通模板',
  多媒体模板: '多媒体模板',
  创建普通模板: '创建普通模板',
  创建多媒体模板: '创建多媒体模板',
  模板首页提示1: '1、短信内容不能含有特殊字符与表情字符,如【】、■、※、✔等,避免模板审核被拒。',
  模板首页提示2:
    '2、普通邀约（纯文本）,70个字符以内（包含邀约）按1条短信计算,超过70个字符时,每增加67个字符,则多增加一条短信；每个标点、数字、字母、中文等均按照一个字符进行计算。',
  模板首页提示3:
    '3、多媒体邀约,邀约模板不能超过1.9M大小,视频上传文件不能超过50M（系统会自动压缩）,且建议播放时长不超过33秒,横屏视频建议1920*1080px,竖屏视频建议1080*1920px,图片大小建议50kb-1.8M范围,横屏图片建议1920*1080px,竖屏图片建议962*1300px。',
  普通邀约模板规范: '普通邀约模板规范',
  多媒体邀约模板规范: '多媒体邀约模板规范',
  营销短信法规政策要求: '营销短信法规政策要求',
  无需审核: '无需审核',
  模板ID: '模板ID',
  模板名称: '模板名称',
  更新时间: '更新时间',
  失效时间: '失效时间',
  主题: '主题',
  模板大小: '模板大小',
  正常可用: '正常可用',
  模板已过期: '模板已过期',
  审核不通过: '审核不通过',
  模板已禁用: '模板已禁用',
  模板不存在: '模板不存在',

  运营商状态: '运营商状态',
  审核备注: '审核备注',
  审核要求: '审核要求',
  邀约: '邀约',
  创建人所属公司: '创建人所属公司',
  创建人: '创建人',
  创建时间: '创建时间',
  中国移动: '中国移动',
  中国联通: '中国联通',
  中国电信: '中国电信',
  港澳台及国外: '港澳台及国外',
  未知: '未知',
  普通模板添加模板名称说明: '仅作普通邀约模板的显示,不作为短信内容发送',

  模板名称不能为空: '模板名称不能为空!',
  模板名称最多输入10个字符: '模板名称最多输入10个字符!',
  模板正文内容: '模板正文内容',
  添加普通邀约模板正文说明1:
    '1、普通邀约（纯文本）,70个字符以内（包含邀约与退订回T）按1条短信计算,超过70个字符时,每增加67个字符,则多增加一条短信；每个标点、数字、字母、中文 等均按照一个字符进行计算,最多可输入1000个字符（包含邀约）；',
  添加普通邀约模板正文说明2:
    '2、正文内容若涉及链接,必须使用插入短链接功能,且在模板正文内容插入短链接之前,首先需要报备链接,且审核通过后生成短链接,',
  去报备链接: '去报备链接',
  模板内容不能为空: '模板内容不能为空',
  模板内容最多输入1000个字符: '模板内容最多输入1000个字符',
  插入短链接: '插入短链接',
  文本框删除短链需先选中链接文本: '文本框删除短链需先选中链接文本',
  请在左侧输入短信内容: '请在左侧输入短信内容',
  短信模板添加成功: '邀约模板添加成功。',
  短信模板添加多媒体邀约模板主题提示1: '1、主题会在发送短信时候显示,模板主题中请勿输入【】[] “”,尽量避免使用特殊符号；',
  短信模板添加多媒体邀约模板主题提示2: '2、主题支持1-15个字符数,不可为空',
  主题不能为空: '主题不能为空',
  模板主题中请勿输入: '模板主题中请勿输入',
  短信模板添加多媒体邀约模板正文提示1: '1、若插入短链接,请确保短链接前后都需要加一个空格符号；',
  短信模板添加多媒体邀约模板正文提示2: '2、模板必须包含文字,且不能为纯文字、纯图片、纯音频、或纯视频；',
  短信模板添加多媒体邀约模板正文提示3: '3、根据运营商的要求,模板大小需要在最大1.9M；',
  短信模板添加多媒体邀约模板正文提示4: '4、模板正文内容不能包含特殊字符,如【】、[ ]等；',
  短信模板添加多媒体邀约模板正文提示5: '5、免流、退订等贴尾信息由系统自动添加,模板内不能含有贴尾字样；',
  短信模板添加多媒体邀约模板正文提示6: '6、在模板正文内容插入短链接之前,首先需要报备链接,且审核通过后生成短链接；',
  文本: '文本',
  模板内容最多输入500个字符: '模板内容最多输入500个字符',
  点击添加: '点击添加',
  短信模板添加多媒体邀约模板图片提示1:
    '1、支持格式PNG/JPG/JPEG/GIF,横图建议：1920*1080px,竖图建议：962*1300,高度不要超过3000px；',
  短信模板添加多媒体邀约模板图片提示2:
    '2、为了确保多媒体邀约大小在1.9M以内,请上传图片时,建议确保图片大小控制在1.8M以内',
  短信模板添加多媒体邀约模板视频提示1: '大小建议不要超过10M,支持格式MP4/3GP,建议上传格式最好为MP4、时长不超过33秒。',
  短信模板添加多媒体邀约模板审核要求提示1:
    '1、您可以再此描述您的审核要求或期望,如模板仅需移动审核,联通、电信不需要审核,希望在2个小时内完成审核',
  选填: '选填',
  短信模板添加多媒体邀约模板备注提示1: '1、可以用于简要记录当前模板的具体用途,如客户生日祝福',
  目前模板大小: '目前模板大小',
  最大: '最大',
  模板正文必须包含文字: '模板正文必须包含文字!',
  模板正文不能为纯文本: '模板正文不能为纯文本!',
  模板正文大小超过: '模板正文大小超过',
  多媒体模板添加成功: '多媒体模板添加成功。',
  视频传压缩提示: '视频正在上传压缩,请勿关闭此页面。',
}
